import { render, staticRenderFns } from "./VoucherLandingPageDialog-gt2.vue?vue&type=template&id=a6ec178e&scoped=true"
import script from "./VoucherLandingPageDialog-gt2.vue?vue&type=script&lang=js"
export * from "./VoucherLandingPageDialog-gt2.vue?vue&type=script&lang=js"
import style0 from "./VoucherLandingPageDialog-gt2.vue?vue&type=style&index=0&id=a6ec178e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6ec178e",
  null
  
)

export default component.exports